import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IOperationResultNoValue } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateInfiniteCustomSurveys } from './useInfiniteCustomSurveys';
import { invalidateInfiniteDonationSurveys } from './useInfiniteDonationSurveys';
import { invalidateInfiniteEventRegistrationSurveys } from './useInfiniteEventRegistrationSurveys';
import { invalidateInfiniteSatisfactionSurveys } from './useInfiniteSatisfactionSurveys';
import { invalidateInfiniteSurveys } from './useInfiniteSurveys';

export function useChangeSurveyCreatorMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ surveyId, surveyType, userId }: { surveyId: string; surveyType: string; userId: string }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { creatorId: userId },
					urlPath: `survey/${surveyType}/${surveyId}/changeCreator`,
				}),
				'PUT'
			);
		},
		onSuccess: () => {
			invalidateInfiniteSatisfactionSurveys();
			invalidateInfiniteEventRegistrationSurveys();
			invalidateInfiniteCustomSurveys();
			invalidateInfiniteSurveys();
			invalidateInfiniteDonationSurveys();
			onSuccess?.();
		},
		onError,
	});
}
